import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MenuSidebar from './MenuSidebar';
import SearchSidebar from './SearchSidebar';

const HomeMobileNavbar = () => {
  const [user, setUser] = useState(null);
  console.log(user)
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [bannerVisible, setBannerVisible] = useState(true);
  const [isSticky, setIsSticky] = useState(false);
  console.log(user , wishlistCount);
  // const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const mobileNavTextClass = `text-sm font-bdogrotesk ${isHomePage ? 'text-white' : 'text-black'}`;

  useEffect(() => {
    // Check if user is logged in
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  useEffect(() => {
    // Check banner visibility by looking for banner element in DOM
    const checkBannerVisibility = () => {
      const banner = document.getElementById('site-banner');
      setBannerVisible(!!banner);
    };

    // Check initially
    checkBannerVisibility();

    // Set up a mutation observer to watch for banner changes
    const observer = new MutationObserver(checkBannerVisibility);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isHomePage) return;

    const handleScroll = () => {
      const bannerHeight = bannerVisible ? 40 : 0;

      // Prefer the hero (video) section as the trigger point
      const heroSection = document.querySelector('.section_hero');
      if (heroSection) {
        const heroRect = heroSection.getBoundingClientRect();
        // When the hero's bottom crosses the banner top, make navbar sticky
        if (heroRect.bottom <= bannerHeight) {
          setIsSticky(true);
        } else {
          setIsSticky(false);
        }
        return;
      }

      // Fallback: mission/intro section
      const missionSection = document.querySelector('.bg-white.py-12');
      if (missionSection) {
        const missionRect = missionSection.getBoundingClientRect();
        if (missionRect.top <= bannerHeight) setIsSticky(true);
        else setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage, bannerVisible]);

  useEffect(() => {
    const loadCount = async () => {
      try {
        const user = localStorage.getItem('user');
        const token = localStorage.getItem('token');
        if (!user || !token) { setCartCount(0); return; }
        const { getCart } = await import('../services/cartService');
        const data = await getCart();
        if (Array.isArray(data)) setCartCount(data.reduce((s, i) => s + (i.qty || i.quantity || 0), 0));
      } catch (e) { setCartCount(0); }
    };

    loadCount();
    const onUpdated = () => loadCount();
    window.addEventListener('cart:updated', onUpdated);
    return () => { window.removeEventListener('cart:updated', onUpdated); };
  }, []);

  // Load wishlist count
  useEffect(() => {
    const loadWishlistCount = async () => {
      const user = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      if (user && token) {
        try {
          const { getWishlist } = await import('../services/wishlistService');
          const data = await getWishlist();
          setWishlistCount(data.length);
        } catch (error) {
          setWishlistCount(0);
        }
      } else {
        setWishlistCount(0);
      }
    };

    loadWishlistCount();

    const onWishlistUpdated = (e) => {
      if (e.detail?.wishlist) {
        setWishlistCount(e.detail.wishlist.length);
      } else {
        loadWishlistCount();
      }
    };

    const onAuthChange = () => loadWishlistCount();

    window.addEventListener('wishlist:updated', onWishlistUpdated);
    window.addEventListener('auth:login', onAuthChange);
    window.addEventListener('auth:logout', onAuthChange);

    return () => {
      window.removeEventListener('wishlist:updated', onWishlistUpdated);
      window.removeEventListener('auth:login', onAuthChange);
      window.removeEventListener('auth:logout', onAuthChange);
    };
  }, []);

  return (
    <div className="font-bdogrotesk">
      <MenuSidebar />
      <SearchSidebar />
      <div
        className={`transition-all duration-300 ${isHomePage ? (isSticky ? 'fixed left-0 right-0 z-[9999] navbar-logo-center-home nav_bg bg-black/95 backdrop-blur-sm' : 'absolute left-0 right-0 z-[9999] navbar-logo-center-home bg-transparent') : 'relative bg-white'} ${isHomePage ? 'text-white' : 'text-black'} px-4 py-2`}
        style={isHomePage ? { top: isSticky ? '0px' : (bannerVisible ? '0px' : '0px') } : undefined}
      >
        <div className="max-w-7xl mx-auto flex items-center">
          {/* left: Menu + Search (text) */}
          <div className="w-1/3 flex items-center space-x-4">
            <button
              onClick={() => window.dispatchEvent(new CustomEvent('menu:toggle', { detail: { open: true } }))}
              className={mobileNavTextClass}
            >
              Menu
            </button>

            <button
              onClick={() => window.dispatchEvent(new CustomEvent('search:toggle', { detail: { open: true } }))}
              className={mobileNavTextClass}
            >
              Search
            </button>
          </div>

          {/* center: logo */}
          <div className="flex-1 flex justify-center">
            <Link to="/" className="flex items-center mt-0.5">
              <img loading="lazy" alt="Nufab Logo" src={isHomePage ? '/images/Logo--White.svg' : '/nufab_black.png'} className="w-20 sm:w-24 object-contain" />
            </Link>
          </div>

          {/* right: Cart (count) + Profile text */}
          <div className="w-1/3 flex items-center justify-end space-x-4">
            <button
              onClick={() => window.dispatchEvent(new CustomEvent('cart:toggle', { detail: { open: true } }))}
              className={`text-sm font-bdogrotesk ${isHomePage ? 'text-white' : 'text-black'} flex items-center`}
            >
              <span>Cart</span>
              <span className={`${isHomePage ? 'text-white' : 'text-black'} px-1`}>{cartCount}</span>
            </button>

            <button
              onClick={() => window.dispatchEvent(new CustomEvent('signup:toggle', { detail: { open: true } }))}
              className={mobileNavTextClass}
            >
              {'Profile'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeMobileNavbar;